import domain from "@/util/domain";

// CDN do bucket de assets (sga-v2-assets). Ver docs/assets/bucket-layout.md.
export const CDN_URL = "https://dozr8la71aog.cloudfront.net";

// Operadores que, por ora, usam as imagens do próprio build (public/img) em vez
// do CDN, enquanto o bucket não está configurado (decisão de 20/10/2026).
// Só logo, favicons 16/32, bandeiras de idioma e logo de PIX têm cópia local.
const LOCAL_ASSET_OPERATORS = ["cartola"];

export const usesLocalAssets = (operator = domain()) =>
  LOCAL_ASSET_OPERATORS.includes(operator);

// URL absoluta: o cupom impresso (plugin-print.js) abre o HTML em outra
// janela, onde um caminho relativo não resolve.
const localUrl = (path) =>
  `${window.location.origin}${process.env.BASE_URL}img/${path}`;

export const operatorLogoUrl = (operator = domain()) =>
  usesLocalAssets(operator)
    ? localUrl(`${operator}/logo.png`)
    : `${CDN_URL}/domains/${operator}/img/logo.png`;

// size: "16x16" | "32x32"
export const operatorFaviconUrl = (size, operator = domain()) =>
  usesLocalAssets(operator)
    ? localUrl(`${operator}/favicon-${size}.png`)
    : `${CDN_URL}/domains/${operator}/img/icons/favicon-${size}.png`;

// code: "br" | "es" | "uk"
export const languageFlagUrl = (code, operator = domain()) =>
  usesLocalAssets(operator)
    ? localUrl(`flags/${code}-flag.webp`)
    : `${CDN_URL}/flags/${code}-flag.png`;

// methodUniqueId: id do método (ex.: "PixPagFast"); logoName: nome do arquivo
// no CDN (ex.: "pagFast"). Localmente só existe o logo genérico de PIX, usado
// para todos os métodos PIX; os demais seguem no CDN.
export const paymentMethodLogoUrl = (
  methodUniqueId,
  logoName,
  operator = domain()
) =>
  usesLocalAssets(operator) && String(methodUniqueId).startsWith("Pix")
    ? localUrl("payment_methods/pixLogoLandscapeWhite.png")
    : `${CDN_URL}/payment_methods/logos/${logoName}.png`;
